<script setup>
/**
 * DateRangeFilter Component
 * Provides a localized start/end HTML5 date picker pair linked directly to an injected reports context.
 * Reads initial URL query fields on execution and cleanses state parameters when unmounted.
 */
import {computed, getCurrentInstance, onUnmounted} from 'vue'

const props = defineProps({
    reportsModule: {
        type: Object,
        required: true
    }
})

// Retrieve the context routing fallbacks proxy wrapper safely
const { proxy } = getCurrentInstance()

// Normalized fallback object mapping targeting shared parent state parameters
const formData = computed(() => props.reportsModule?.formData || {})

// Replacing the created phase logic - fires immediately during setup execution
const initRouteQueryState = () => {
    formData.value.startDate = proxy.$route?.query?.startDate || ''
    formData.value.endDate = proxy.$route?.query?.endDate || ''
}
initRouteQueryState()

// Clean up mutation boundaries when navigating away from the filter component
onUnmounted(() => {
    if (formData.value) {
        delete formData.value.startDate
        delete formData.value.endDate
    }
})
</script>

<template>
    <span class="d-flex align-items-center">
        <input
            type="date"
            required
            v-model="formData.startDate"
            class="form-control form-control-sm"
            oninvalid="this.setCustomValidity('Please enter a start date')"
            oninput="this.setCustomValidity('')"
        >
        <span class="ms-2 text-muted">to</span>
        <input
            type="date"
            required
            v-model="formData.endDate"
            class="ms-2 form-control form-control-sm"
            oninvalid="this.setCustomValidity('Please enter an end date')"
            oninput="this.setCustomValidity('')"
        >
    </span>
</template>